import * as getters from "./user.getters";
import * as actions from "./user.actions";
import * as mutations from "./user.mutations";

const state = {
    user: false,
    userLocation: false,
    userCoordinates: false,
    userLocationAddress: false,
    openPOIAfterLogin: false,
    sessionData: false,
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}